import { useSiteSettingsStore } from '@/stores/siteSettings'

function setMeta(name: string, content: string, isProperty = false) {
  if (!content) return
  const attr = isProperty ? 'property' : 'name'
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

export function useSiteHead() {
  const store = useSiteSettingsStore()

  function applyHead() {
    const v = store.values

    if (v.meta_title) document.title = v.meta_title
    if (v.meta_description) setMeta('description', v.meta_description)

    // Open Graph
    if (v.meta_title) setMeta('og:title', v.meta_title, true)
    if (v.meta_description) setMeta('og:description', v.meta_description, true)

    // Twitter
    if (v.meta_title) setMeta('twitter:title', v.meta_title)
    if (v.meta_description) setMeta('twitter:description', v.meta_description)
  }

  function injectAnalytics(measurementId: string) {
    if (!measurementId || !/^G-/.test(measurementId)) return
    if (document.querySelector(`script[data-ga-id="${measurementId}"]`)) return

    const loader = document.createElement('script')
    loader.async = true
    loader.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
    loader.setAttribute('data-ga-id', measurementId)
    document.head.appendChild(loader)

    const config = document.createElement('script')
    config.textContent = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${measurementId}');`
    document.head.appendChild(config)
  }

  return { applyHead, injectAnalytics }
}
